import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface RankRow {
  key: string
  label: string
  /** Dòng phụ dưới tên: nhãn vai trò, số đơn… */
  meta?: ReactNode
  value: number
  display: string
}

/**
 * Bảng xếp hạng dạng thanh ngang. Một chuỗi số liệu nên mọi thanh cùng một
 * màu; giá trị ghi bằng chữ ở đầu dòng nên không cần tooltip. Thanh dài nhất
 * = giá trị lớn nhất, các thanh khác theo đúng tỷ lệ.
 */
export function RankBars({ rows, className }: { rows: RankRow[]; className?: string }) {
  const max = Math.max(0, ...rows.map((r) => r.value))
  return (
    <ol className={cn('divide-y divide-rule', className)}>
      {rows.map((r, i) => (
        <li key={r.key} className="grid grid-cols-[1.5rem_minmax(0,1fr)_auto] items-center gap-x-3 px-4 py-3">
          <span className="text-center text-sm font-semibold tabular-nums text-muted">{i + 1}</span>
          <div className="min-w-0">
            <p className="truncate text-sm font-medium text-ink" title={r.label}>{r.label}</p>
            {r.meta && <div className="mt-0.5 flex items-center gap-2 text-xs text-muted">{r.meta}</div>}
            <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-paperSoft" aria-hidden>
              <div
                className="h-full rounded-full bg-accent"
                style={{ width: `${max > 0 ? Math.max((r.value / max) * 100, 2) : 0}%` }}
              />
            </div>
          </div>
          <span className="self-start text-sm font-semibold tabular-nums text-ink">{r.display}</span>
        </li>
      ))}
    </ol>
  )
}
